var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background bg-dark"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("Bubble Game")]),_c('h1',{staticStyle:{"color":"#ff6688"}},[_vm._v("Click to see bubble pop out!")]),_c('div',{staticClass:"background",staticStyle:{"position":"relative"},attrs:{"id":"bubbleapp"},on:{"click":function($event){return _vm.createBubble($event)}}},_vm._l((_vm.bubbles),function(bubble){return _c('div',{key:bubble.id,staticClass:"absolute rounded-full transition-all duration-300",style:({
        position: 'absolute',
        left: `${bubble.x}px`,
        top: `${bubble.y}px`,
        width: `${bubble.size}px`,
        height: `${bubble.size}px`,
        backgroundColor: bubble.color,
        border: `5px solid ${bubble.borderColor}`,
        opacity: bubble.opacity,
      }),on:{"click":function($event){return _vm.popBubble(bubble.id)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }